// src/components/Layout.js
import React, { useState, useEffect } from "react";
import Sidebar from "./sidebar/Sidebar";
import Navbar from "./navbar/Navbar";

const Layout = ({
  children,
  title,
  subtitle,
  userName = "Abhinav Kumar",
  userMembership = "Premium Member",
}) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  // Track sidebar collapse state for navbar adjustment
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1024 && window.innerWidth > 768) {
        setIsSidebarCollapsed(true);
      } else if (window.innerWidth > 1024) {
        setIsSidebarCollapsed(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="wc-layout-container">
      <Sidebar />
      <Navbar
        title={title}
        subtitle={subtitle}
        userName={userName}
        userMembership={userMembership}
      />
      <main
        className={`wc-main-content ${
          isSidebarCollapsed ? "sidebar-collapsed" : ""
        }`}
      >
        {children}
      </main>
    </div>
  );
};

export default Layout;
